import { render, staticRenderFns } from "./PanelWithFileInput.vue?vue&type=template&id=7051af51&lang=pug&"
import script from "./PanelWithFileInput.vue?vue&type=script&lang=ts&"
export * from "./PanelWithFileInput.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithFileInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports